import React from "react";

const Sick = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M21.517 3.24H17.78v2.336h2.569v4.398a7.015 7.015 0 01-7.007 7.007 7.015 7.015 0 01-7.006-7.007V5.576h2.49V3.24H5.169C4.523 3.24 4 3.763 4 4.408v5.566c0 5.152 4.19 9.343 9.342 9.343s9.342-4.191 9.342-9.343V4.408c0-.645-.522-1.168-1.167-1.168z"
            fill={fill}
        />
        <path className="u_fill"
            d="M26.07 20.298v5.528c0 3.22-2.619 5.838-5.838 5.838a5.846 5.846 0 01-5.84-5.838v-7.63h-2.335v7.63c0 4.507 3.667 8.174 8.175 8.174 4.507 0 8.174-3.667 8.174-8.174v-5.528H26.07z"
            fill={fill}
        />
        <path className="u_fill"
            d="M27.243 12.75a4.326 4.326 0 00-4.321 4.32 4.326 4.326 0 004.32 4.32 4.326 4.326 0 004.322-4.32 4.326 4.326 0 00-4.321-4.32zM8.783 2c-.645 0-1.168.523-1.168 1.168v2.491a1.168 1.168 0 102.336 0V3.168C9.95 2.523 9.428 2 8.783 2zM17.82 2c-.645 0-1.167.523-1.167 1.168v2.491a1.168 1.168 0 102.335 0V3.168c0-.645-.523-1.168-1.168-1.168z"
            fill={fill}
        />
    </svg>
);

export default Sick;